module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "page-wrapper"
  }, [_c('component-header'), _vm._v(" "), _c('div', {
    staticClass: "main"
  }, [_c('div', {
    staticClass: "outer-admin"
  }, [_c('div', {
    staticClass: "wrapper-admin"
  }, [_c('component-sidebar'), _vm._v(" "), _c('div', {
    staticClass: "content-admin"
  }, [_c('div', {
    staticClass: "content-admin-wrapper"
  }, [_c('div', {
    staticClass: "content-admin-main"
  }, [_c('div', {
    staticClass: "content-admin-main-inner"
  }, [_c('div', {
    staticClass: "container-fluid"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-12 col-lg-12",
    staticStyle: {
      "margin-right": "5em"
    }
  }, [_c('div', {
    staticClass: "content fld-left"
  }, [_c('div', {}, [_c('div', {
    attrs: {
      "role": "",
      "id": "one"
    }
  }, [_c('div', {
    staticClass: "fld-lft-adjust"
  }, [_vm._m(0), _vm._v(" "), (_vm.loading) ? _c('div', {
    staticClass: "row"
  }, [_vm._m(1)]) : _c('div', [(_vm.cnpay_transactions.length != 0) ? _c('div', {
    attrs: {
      "id": "remita-transactions"
    }
  }, [_c('div', {
    staticClass: " p20 mb30 hidden-sm hidden-xs"
  }, [_c('div', {
    staticClass: "p20 col-md-8 col-md-offset-2",
    staticStyle: {
      "overflow-x": "auto",
      "background": "#ffffff"
    }
  }, [_vm._m(2), _vm._v(" "), _c('table', {
    staticClass: "table"
  }, [_vm._m(3), _vm._v(" "), _vm._l((_vm.cnpay_transactions), function(txn) {
    return _c('tr', [_c('td', [_vm._v(_vm._s(txn.cnpay_txn_date))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(txn.cnpay_txn_ref))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(txn.cnpay_txn_service))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.formatCurrency(txn.cnpay_txn_total_amt_paid)))]), _vm._v(" "), _c('td', [_c('button', {
      staticClass: "btn btn-default btn-sm",
      attrs: {
        "type": "button",
        "data-toggle": "modal",
        "data-target": "#viewTransaction"
      },
      on: {
        "click": function($event) {
          _vm.setTransaction(txn, txn.cnpay_txn_type)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-info-circle"
    }), _vm._v(" More Details")])])])
  })], 2)])]), _vm._v(" "), _c('div', {
    staticClass: "background-white p20 mb30 hidden-md hidden-lg"
  }, [_vm._m(4), _vm._v(" "), _c('table', {
    staticClass: "table"
  }, _vm._l((_vm.cnpay_transactions), function(txn) {
    return _c('tr', [_c('td', {
      staticStyle: {
        "padding": "1em"
      }
    }, [_c('p', [_c('b', [_vm._v("Date: ")]), _vm._v(_vm._s(txn.cnpay_txn_date))]), _vm._v(" "), _c('p', [_c('b', [_vm._v("REF: ")]), _vm._v(_vm._s(txn.cnpay_txn_ref))]), _vm._v(" "), _c('p', [_c('b', [_vm._v("Transaction: ")]), _vm._v(_vm._s(txn.cnpay_txn_service))]), _vm._v(" "), _c('p', [_c('b', [_vm._v("Amount: ")]), _vm._v("₦" + _vm._s(_vm.formatCurrency(txn.cnpay_txn_total_amt_paid)))]), _vm._v(" "), _c('p', [_c('button', {
      staticClass: "pull-left btn btn-default btn-sm",
      attrs: {
        "type": "button",
        "data-toggle": "modal",
        "data-target": "#viewTransaction"
      },
      on: {
        "click": function($event) {
          _vm.setTransaction(txn, txn.cnpay_txn_type)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-info-circle"
    }), _vm._v(" More Details")])])])])
  }))])]) : _c('div', [_c('p', {
    staticStyle: {
      "color": "#ff0000"
    }
  }, [_vm._v("You don't have any CNpay Transactions yet")])])])])])])])])])])])]), _vm._v(" "), _c('component-footer')], 1)])], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "modal fade",
    staticStyle: {
      "margin-top": "7em"
    },
    attrs: {
      "id": "viewTransaction",
      "tabindex": "-10",
      "role": "dialog",
      "aria-labelledby": "myModalLabel"
    }
  }, [_c('div', {
    staticClass: "modal-dialog",
    attrs: {
      "role": "document"
    }
  }, [_c('div', {
    staticClass: "modal-content",
    staticStyle: {
      "border-radius": "3px"
    }
  }, [_c('button', {
    staticClass: "pull-right btn btn-default",
    attrs: {
      "type": "button",
      "data-dismiss": "modal"
    },
    on: {
      "click": function($event) {
        _vm.closeModal('#viewTransaction')
      }
    }
  }, [_vm._v("Close")]), _vm._v(" "), _c('br'), _c('br'), _vm._v(" "), (!_vm.show_payment_receipt) ? _c('div', {
    staticClass: "modal-body"
  }, [_c('h5', {
    staticStyle: {
      "font-weight": "bolder"
    }
  }, [_vm._v("Transaction Details")]), _vm._v(" "), _c('hr'), _vm._v(" "), (_vm.cnpay_transaction_type == 1) ? _c('div', [_c('p', [_c('b', [_vm._v("Date: ")]), _vm._v(_vm._s(_vm.cnpay_transaction.cnpay_reg_date))]), _vm._v(" "), _c('p', [_c('b', [_vm._v("REF: ")]), _vm._v(_vm._s(_vm.cnpay_transaction.cnpay_ref))]), _vm._v(" "), _c('p', [_c('b', [_vm._v("RRR Code: ")]), _vm._v(_vm._s(_vm.cnpay_transaction.cnpay_rrr))]), _vm._v(" "), _c('p', [_c('b', [_vm._v("Transaction Amount: ")]), _vm._v("₦" + _vm._s(_vm.formatCurrency(_vm.cnpay_transaction.cnpay_rrr_amount)))]), _vm._v(" "), _c('p', [_c('b', [_vm._v("Transaction Charges: ")]), _vm._v("₦" + _vm._s(_vm.formatCurrency(_vm.cnpay_transaction.cnpay_rrr_charges)))]), _vm._v(" "), _c('p', [_c('b', [_vm._v("CNpay Charges: ")]), _vm._v("₦" + _vm._s(_vm.formatCurrency(_vm.cnpay_transaction.cnpay_cnpay_charges)))]), _vm._v(" "), _c('p', [_c('b', [_vm._v("Total Amount Paid: ")]), _vm._v("₦" + _vm._s(_vm.formatCurrency(_vm.cnpay_transaction.cnpay_total_paid_amt)))])]) : _vm._e(), _vm._v(" "), (_vm.cnpay_transaction_type == 2) ? _c('div', [_c('p', [_c('b', [_vm._v("Date: ")]), _vm._v(_vm._s(_vm.cnpay_transaction.cnpay_paga_reg_date))]), _vm._v(" "), _c('p', [_c('b', [_vm._v("REF: ")]), _vm._v(_vm._s(_vm.cnpay_transaction.cnpay_paga_ref))]), _vm._v(" "), _c('p', [_c('b', [_vm._v("Transaction: ")]), _vm._v(_vm._s(_vm.cnpay_transaction.cnpay_paga_merchant_service_name))]), _vm._v(" "), _c('p', [_c('b', [_vm._v(_vm._s(_vm.cnpay_transaction.cnpay_paga_set_transaction_confirmationCode))])]), _vm._v(" "), _c('p', [_c('b', [_vm._v("Transaction Amount: ")]), _vm._v("₦" + _vm._s(_vm.formatCurrency(_vm.cnpay_transaction.cnpay_paga_merchant_service_price)))]), _vm._v(" "), _c('p', [_c('b', [_vm._v("CNpayCharges: ")]), _vm._v("₦" + _vm._s(_vm.formatCurrency(_vm.cnpay_transaction.cnpay_paga_merchant_service_commission)))]), _vm._v(" "), _c('p', [_c('b', [_vm._v("Total Amount Paid: ")]), _vm._v("₦" + _vm._s(_vm.formatCurrency(_vm.cnpay_transaction.cnpay_paga_total_paid_amt)))]), _vm._v(" "), (_vm.cnpay_transaction.cnpay_paga_transaction_status == 1) ? _c('p', [_c('b', [_vm._v("Transaction Status: ")]), _vm._v("Payment Made, Awaiting Service Delivery")]) : _vm._e(), _vm._v(" "), (_vm.cnpay_transaction.cnpay_paga_transaction_status == 2) ? _c('p', [_c('b', [_vm._v("Transaction Status: ")]), _vm._v("Successful")]) : _vm._e()]) : _vm._e(), _vm._v(" "), _c('button', {
    staticClass: "pull-right btn btn-default btn-sm",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.show_payment_receipt = true
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-info-circle"
  }), _vm._v(" View Receipt")]), _vm._v("\r\n            `   "), _c('div', {
    staticStyle: {
      "clear": "both"
    }
  })]) : _vm._e(), _vm._v(" "), (_vm.show_payment_receipt) ? _c('div', {
    staticClass: "modal-body"
  }, [_c('div', {
    staticStyle: {
      "width": "342px !important"
    },
    attrs: {
      "id": "paymod"
    }
  }, [_c('div', {
    staticClass: "table rctable",
    staticStyle: {
      "border": "none",
      "margin-top": "1em",
      "color": "#000000",
      "font-weight": "bolder",
      "margin-bottom": "0.1em !important"
    }
  }, [_c('table', {
    staticStyle: {
      "border": "none",
      "width": "100%",
      "overflow": "hidden"
    }
  }, [_c('tr', {}, [_vm._m(5), _vm._v(" "), _c('td', [_c('div', {
    staticStyle: {
      "margin-bottom": "0.1em",
      "margin-left": "0px"
    }
  }, [(_vm.cnpay_transaction.payment_merchant_logo != '') ? _c('span', [_c('img', {
    staticStyle: {
      "height": "45px"
    },
    attrs: {
      "src": _vm.img_url + _vm.cnpay_transaction.payment_merchant_logo
    }
  })]) : _c('span', [_c('p', {
    staticClass: "service-pay-title-logo"
  }, [_vm._v(_vm._s(_vm.cnpay_transaction.payment_merchant_name))])])])])])])]), _vm._v(" "), _vm._m(6), _vm._v(" "), _c('div', {
    staticClass: "table rctable",
    staticStyle: {
      "color": "#000000",
      "font-weight": "bolder"
    }
  }, [_c('table', {}, [_c('tr', [_c('td', [_vm._v("Payment:")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.cnpay_transaction.cnpay_paga_merchant_service_name))])]), _vm._v(" "), (_vm.cnpay_transaction.cnpay_paga_transaction_payer_merchant_name && (_vm.cnpay_transaction.cnpay_paga_transaction_payer_merchant_name != '')) ? _c('tr', [_c('td', [_vm._v("From:")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.cnpay_transaction.cnpay_paga_transaction_payer_merchant_name))])]) : _vm._e(), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Number:")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.cnpay_transaction.cnpay_paga_payercodeAtBiller))])]), _vm._v(" "), (_vm.cnpay_transaction.cnpay_paga_transaction_payer_merchant_address && (_vm.cnpay_transaction.cnpay_paga_transaction_payer_merchant_address != '')) ? _c('tr', [_c('td', [_vm._v("Address:")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.cnpay_transaction.cnpay_paga_transaction_payer_merchant_address))])]) : _vm._e(), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Date:")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.cnpay_transaction.cnpay_paga_reg_date))])]), _vm._v(" "), (_vm.cnpay_transaction.cnpay_paga_transaction_confirmationCode != 0) ? _c('tr', [_c('td', [_vm._v("Token:")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.setFormattedVoucher(_vm.cnpay_transaction.cnpay_paga_transaction_confirmationCode)))])]) : _vm._e(), _vm._v(" "), ((_vm.cnpay_transaction.cnpay_paga_transaction_service_purchased_units != '') && (_vm.cnpay_transaction.cnpay_paga_transaction_service_purchased_unitType != '')) ? _c('tr', [_c('td', [_vm._v("Units:")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.cnpay_transaction.cnpay_paga_transaction_service_purchased_units) + " " + _vm._s(_vm.cnpay_transaction.cnpay_paga_transaction_service_purchased_unitType))])]) : ((_vm.cnpay_transaction.cnpay_paga_transaction_service_purchased_units != '')) ? _c('tr', [_c('td', [_vm._v("Units:")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.cnpay_transaction.cnpay_paga_transaction_service_purchased_units))])]) : _vm._e(), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Amount:")]), _vm._v(" "), _c('td', [_vm._v("₦" + _vm._s(_vm.formatCurrency(_vm.cnpay_transaction.cnpay_paga_merchant_service_price)))])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("CNpay Charges:")]), _vm._v(" "), _c('td', [_vm._v("₦" + _vm._s(_vm.formatCurrency(_vm.cnpay_transaction.cnpay_paga_merchant_service_commission)))])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Total:")]), _vm._v(" "), _c('td', [_vm._v("₦" + _vm._s(_vm.formatCurrency(_vm.cnpay_transaction.cnpay_paga_total_paid_amt)))])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Transaction Status:")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.cnpay_transaction.cnpay_paga_transaction_status_name))])])]), _vm._v(" "), _vm._m(7)])]), _vm._v(" "), _c('div', {
    staticClass: "left",
    staticStyle: {
      "clear": "both"
    }
  }, [_c('button', {
    staticClass: "btn btn btn-primary btn-xs",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.printDiv('paymod', 'Utility Bill Receipt')
      }
    }
  }, [_vm._v("Print")]), _vm._v("   \r\n                    "), _c('button', {
    staticClass: "btn btn btn-primary btn-xs",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.saveDiv('paymod', 'Utility Bill Receipt')
      }
    }
  }, [_vm._v("Save\r\n                        "), (_vm.downloading) ? _c('span', [_c('img', {
    attrs: {
      "src": "/static/assets/img/loader.gif",
      "height": "20"
    }
  })]) : _vm._e()]), _vm._v("   \r\n                    "), _c('button', {
    staticClass: "btn btn btn-primary btn-xs",
    attrs: {
      "type": "button",
      "data-dismiss": "modal"
    },
    on: {
      "click": function($event) {
        _vm.closeModal('paywith')
      }
    }
  }, [_vm._v("Close")])]), _vm._v(" "), _c('br'), _c('br'), _c('br')]) : _vm._e()])])])], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "page-title"
  }, [_c('h1', {
    attrs: {
      "align": "center"
    }
  }, [_vm._v("My CNpay Transactions")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-md-6 col-md-offset-5 col-sm-12",
    staticStyle: {
      "padding": "5em"
    }
  }, [_c('img', {
    attrs: {
      "src": "static/assets/img/loader.gif"
    }
  }), _vm._v(" "), _c('p', [_vm._v("loading...")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h5', [_c('u', [_vm._v("Transactions")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tr', [_c('th', [_vm._v("~"), _c('span', {
    staticStyle: {
      "font-size": "11px"
    }
  }, [_vm._v("Date")])]), _vm._v(" "), _c('th', [_vm._v("REF")]), _vm._v(" "), _c('th', [_vm._v("Transaction")]), _vm._v(" "), _c('th', [_vm._v("Amount(₦)")]), _vm._v(" "), _c('th', [_vm._v(" --- ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h5', [_c('u', [_vm._v("Transactions")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', [_c('div', {
    staticClass: "pull-left",
    staticStyle: {
      "margin-top": "-1em",
      "margin-left": "0em"
    }
  }, [_c('h6', {
    staticClass: "headings"
  }, [_c('span', {
    staticStyle: {
      "color": "#22baae",
      "font-size": "14px"
    }
  }, [_vm._v("CN")]), _c('span', {
    staticStyle: {
      "color": "#e7c619",
      "font-size": "14px"
    }
  }, [_vm._v("pay")])]), _vm._v(" "), _c('p', {
    staticStyle: {
      "font-size": "10px",
      "margin-top": "-1em"
    }
  }, [_c('b', [_vm._v("pay bills with a click 👌")])]), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "margin-left": "1em"
    }
  }, [_c('h5', {
    staticStyle: {
      "font-size": "14px"
    }
  }, [_c('u', [_vm._v("CNpay Payment Receipt")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticStyle: {
      "margin-top": "1em",
      "margin-left": "1em",
      "font-size": "11px",
      "text-align": "left"
    }
  }, [_vm._v("Thank you for choosing CNpay."), _c('br'), _vm._v("\r\n                            Cityneeds™ ... meet everyday needs on the go!")])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7d2253c4"}!./src/components/CNpayTransactions/template.html
// module id = 309
// module chunks = 0